<div class="w-[100%] flex justify-end" *ngIf="isEdit">
  <div class="flex justify-start mr-[11px]">
    <div
      class="ml-[12px] bg-[#f9dacf] px-[6px] pt-[4px] pb-[4px] rounded-[50%] flex justify-end items-center"
    >
      <img
        src="assets/icons/close.svg"
        alt="close"
        class="cursor-pointer w-[14px]"
        (click)="cancel()"
      />
    </div>
    <div class="ml-[12px] bg-[#f9dacf] p-[4px] rounded-[50%]">
      <img
        src="assets/icons/save.svg"
        alt="save"
        class="cursor-pointer w-[20px] pr-[2px]"
        (click)="save()"
      />
    </div>
  </div>
</div>

<div class="flex items-center">
  <div class="mt-2 flex space-x-4 mr-[10px]">
    <div
      *ngFor="let file of uploadedFiles; let i = index"
      class="flex flex-col items-center space-y-0"
    >
      <div
        class="relative w-24 h-24 border border-gray-300 rounded-md overflow-hidden"
        title="{{ splitFilename(file?.file_path) }}"
      >
        <img
          [src]="getFileIcon(file)"
          alt="File Preview"
          class="object-cover w-[103px] h-[103px]"
          (click)="openPreview(i)"
        />

        <div *ngIf="isEdit">
          <button
            type="button"
            (click)="removeFile(i, file)"
            class="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
            title="Remove File"
            style="
              height: 25px;
              width: 25px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            ✕
          </button>
        </div>
      </div>
    </div>

    <!-- File upload button stays in row -->
    <div *ngIf="isEdit">
      <button
        type="button"
        (click)="fileInput.click()"
        class="bg-[#D8EEFF] hover:bg-[#D8EEFF] w-[103px] h-[98px] !text-center text-black font-bold py-2 px-8 rounded inline-flex items-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="39"
          height="39"
          viewBox="0 0 39 39"
          fill="none"
        >
          <path
            d="M19.2465 0.0151666L19.5 0C20.0307 7.00062e-05 20.5429 0.194905 20.9395 0.54755C21.3361 0.900195 21.5894 1.38612 21.6515 1.91317L21.6667 2.16667V17.3333H36.8333C37.364 17.3334 37.8762 17.5282 38.2728 17.8809C38.6694 18.2335 38.9227 18.7195 38.9848 19.2465L39 19.5C38.9999 20.0307 38.8051 20.5429 38.4524 20.9395C38.0998 21.3361 37.6139 21.5894 37.0868 21.6515L36.8333 21.6667H21.6667V36.8333C21.6666 37.364 21.4718 37.8762 21.1191 38.2728C20.7665 38.6694 20.2805 38.9227 19.7535 38.9848L19.5 39C18.9693 38.9999 18.4571 38.8051 18.0605 38.4524C17.664 38.0998 17.4106 37.6139 17.3485 37.0868L17.3333 36.8333V21.6667H2.16667C1.63598 21.6666 1.12377 21.4718 0.727194 21.1191C0.330618 20.7665 0.0772572 20.2805 0.0151666 19.7535L0 19.5C7.00062e-05 18.9693 0.194905 18.4571 0.54755 18.0605C0.900195 17.664 1.38612 17.4106 1.91317 17.3485L2.16667 17.3333H17.3333V2.16667C17.3334 1.63598 17.5282 1.12377 17.8809 0.727194C18.2335 0.330618 18.7195 0.0772572 19.2465 0.0151666Z"
            fill="black"
            fill-opacity="0.7"
          />
        </svg>
      </button>
      <input
        type="file"
        id="contractFile"
        #fileInput
        (change)="onFileUpload($event, false)"
        class="hidden"
        multiple
      />
    </div>
  </div>
</div>

<!-- Image Preview Modal -->
<div
  *ngIf="selectedImage !== null"
  class="fixed top-0 left-0 flex flex-col items-center justify-center z-50 h-[100%] w-[100%]"
>
  <div
    class="bg-[#bcbcd5] rounded-lg p-4 relative w-full h-full flex flex-col justify-center items-center"
    style="background-color: rgba(51, 51, 53, 0.8)"
  >
    <!-- Previous Button -->
    <button
      type="button"
      *ngIf="currentImageIndex > 0"
      (click)="prevImage()"
      class="absolute left-4 top-[50%] bg-gray-300 text-dark p-5"
      title="Previous"
    >
      <span style="font-size: 38px">‹</span>
    </button>

    <ng-container
      *ngIf="isImageFile(uploadedFiles[currentImageIndex]); else pdfIcon"
    >
      <!-- preview -->

      <img
        [src]="
          isEdit
            ? uploadedFiles[currentImageIndex].file_path
              ? base_path + uploadedFiles[currentImageIndex].file_path
              : uploadedFiles[currentImageIndex].preview
            : base_path + uploadedFiles[currentImageIndex].file_path
        "
        alt="Preview"
        class="object-scale-down w-100 h-[90vh] items-center"
      />
    </ng-container>
    <ng-template #pdfIcon>
      <img
        src="assets/images/pdf-icon.png"
        alt="File Preview"
        class="object-cover w-full h-full"
      />
    </ng-template>

    <!-- Next Button -->
    <button
      type="button"
      *ngIf="currentImageIndex < uploadedFiles.length - 1"
      (click)="nextImage()"
      class="absolute right-4 top-[50%] bg-gray-300 text-dark p-5"
      title="Next"
    >
      <span style="font-size: 38px">›</span>
    </button>

    <!-- Close Button -->
    <button
      type="button"
      (click)="closePreview()"
      class="absolute top-2 right-2 bg-red-500 text-white rounded-full w-[31px] h-[31px] flex justify-center items-center p-2 hover:bg-red-600"
      title="Close Preview"
    >
      ✕
    </button>

    <!-- Thumbnails -->
    <div class="flex flex-wrap justify-center mt-4">
      <div
        *ngFor="let file of uploadedFiles; let i = index"
        class="relative mx-2 w-16 h-16 border border-gray-300 rounded-md overflow-hidden cursor-pointer"
        (click)="openPreview(i)"
      >
        <!-- preview -->
        <img
          [src]="getFileIcon(file)"
          alt="Thumbnail"
          class="object-cover w-full h-full"
        />
      </div>
    </div>
  </div>
</div>
